export const getAll = () => fetch('https://rickandmortyapi.com/api/character').then(res => res.json());